// src/components/MealFeedbackActions.js

import React from 'react';
import { Button } from '../../../shared/components/ui';
import { useTranslation } from 'react-i18next';

const MealFeedbackActions = ({
    meal,
    mealKey,
    canGiveFeedback = true,
    evaluatedMeals = {},
    onFeedback
}) => {
    const { t } = useTranslation();
    if (!canGiveFeedback) {
        return (
            <div className="flex items-center gap-2">
                <span className="text-sm text-gray-500">
                    🔒 {t('menu.display.feedbackLocked') || 'Feedback no disponible'}
                </span>
            </div>
        );
    }

    if (evaluatedMeals[mealKey]?.evaluated) {
        return (
            <div className="flex items-center gap-2">
                <span className="text-lg">
                    {evaluatedMeals[mealKey].liked ? '👍' : '👎'}
                </span>
                <span className="text-sm text-green-600 font-medium">
                    {t('menu.display.feedbackSaved') || 'Preferencia guardada'}
                </span>
            </div>
        );
    }

    return (
        <>
            <Button
                variant="ghost"
                size="sm"
                onClick={() => onFeedback && onFeedback(mealKey, meal.name, true)}
                className="text-green-600 hover:bg-green-50 border border-green-200"
            >
                👍 {t('menu.display.like') || 'Me gusta'}
            </Button>
            <Button
                variant="ghost"
                size="sm"
                onClick={() => onFeedback && onFeedback(mealKey, meal.name, false)}
                className="text-red-600 hover:bg-red-50 border border-red-200"
            >
                👎 {t('menu.display.dislike') || 'No me gusta'}
            </Button>
        </>
    );
};

export default MealFeedbackActions;
